/* eslint-disable max-len */
import React from 'react';
import linkifyHtml from 'linkify-html';
import RemoveIcon from '@mui/icons-material/Remove';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CloseIcon from '@mui/icons-material/Close';
import * as linkify from 'linkifyjs';
import { v4 } from 'uuid';
import { generatePresignedUrl } from '../actions/presence_actions';
import axios from 'axios';
import { catchErr } from '../../libs/HelperContent';

export const getRelativeDate = (timestamp) =>
{
	const inputDate = new Date(timestamp);

	const today = new Date();

	today.setHours(0, 0, 0, 0);
	const todayTime = today.valueOf();

	const todayEnd = new Date(today);

	todayEnd.setHours(23, 59, 59, 999);
	const todayEndTime = todayEnd.valueOf();

	const yesterday = new Date(today);

	yesterday.setDate(today.getDate() - 1);
	const yesterdayTime = yesterday.valueOf();

	const inputTime = inputDate.valueOf();

	if (inputTime >= todayTime && inputTime <= todayEndTime)
	{
		return 'Today';
	}
	else if (inputTime >= yesterdayTime && inputTime < todayTime)
	{
		return 'Yesterday';
	}
	else
	{
		return inputDate.toLocaleDateString('en-US', {
			day   : '2-digit',
			month : 'long',
			year  : 'numeric'
		});
	}
};

export const requestMicrophoneAccess = async () =>
{
	try
	{
		const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

		return stream;
	}
	catch (err)
	{
		// eslint-disable-next-line no-console
		console.error('Error accessing microphone:', err);

		return false;
	}
};

const writeString = (view, offset, string) =>
{
	for (let i = 0; i < string.length; i++)
	{
		view.setUint8(offset + i, string.charCodeAt(i));
	}
};
const encodeWav = (audioBuffer) =>
{
	const numOfChannels = audioBuffer.numberOfChannels;
	const sampleRate = audioBuffer.sampleRate;
	const format = 1; // PCM format
	const bitDepth = 16; // 16-bit audio
	const samples = audioBuffer.getChannelData(0); // Use the first channel
	const buffer = new ArrayBuffer(44 + samples.length * 2); // Header + data
	const view = new DataView(buffer);
	// WAV file header

	writeString(view, 0, 'RIFF');
	view.setUint32(4, 36 + samples.length * 2, true); // File size - 8
	writeString(view, 8, 'WAVE');
	writeString(view, 12, 'fmt ');
	view.setUint32(16, 16, true); // Subchunk1 size (16 for PCM)
	view.setUint16(20, format, true); // Audio format (1 for PCM)
	view.setUint16(22, numOfChannels, true); // Number of channels
	view.setUint32(24, sampleRate, true); // Sample rate
	view.setUint32(28, sampleRate * numOfChannels * bitDepth / 8, true); // Byte rate
	view.setUint16(32, numOfChannels * bitDepth / 8, true); // Block align
	view.setUint16(34, bitDepth, true); // Bits per sample
	writeString(view, 36, 'data');
	view.setUint32(40, samples.length * 2, true); // Subchunk2 size
	// Write PCM samples
	let offset = 44;

	for (let i = 0; i < samples.length; i++)
	{
		const s = Math.max(-1, Math.min(1, samples[i]));

		view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
		offset += 2;
	}

	return new Blob([ view ], { type: 'audio/wav' });
};

export const convertToWav:(blob) => Promise<Blob> = (audioBlob) =>
{
	return new Promise((resolve, reject) =>
	{
		const reader = new FileReader();

		reader.onload = () =>
		{
			const audioContext = new AudioContext();

			audioContext.decodeAudioData(reader.result as ArrayBuffer).then((audioBuffer) =>
			{
				const wavBlob = encodeWav(audioBuffer);

				resolve(wavBlob);
			})
				.catch(reject);
		};
		reader.onerror = reject;
		reader.readAsArrayBuffer(audioBlob);
	});
};

export const normalizeValue = (value, min, max) =>
{
	return ((value - min) * 100) / (max - min);
};

export const renderElapsedTime = (duration = 0) =>
{
	const minutes = Math.floor(duration / 60);
	const seconds = Math.floor(duration % 60);

	return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

export 	const handlePauseOtherAudios =
(audioEl:HTMLAudioElement | null = null) =>
{
	const audioElements = document.querySelectorAll('audio');

	audioElements.forEach((audio) =>
	{
		if (audio !== audioEl)
		{
			audio.pause();
		}
	});
};
export const extractLinks = (text) =>
{
	const foundLinks = linkify.find(text);

	return foundLinks.map((link) => link.href);
};

export const ExtractLinksandMention = (text, participantList, mentionedList) =>
{
	// Handle normal link conversion and linkify
	const safeText = text?.replace(/</g, '&lt;').replace(/&lt;a\s+[^&gt;]*&gt;.*?&lt;\/a&gt;/gi, (match) =>
	{
		return match?.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
	});

	const linkifiedText = linkifyHtml(safeText, {
		defaultProtocol : 'https',
		target          : '_blank',
		rel             : 'noopener noreferrer'
	}).replace(/<a\s+href="([^"]+)"/g, (match, url) =>
	{
		return `<a href="${url}" target="_blank" rel="noopener noreferrer" data-link="${url}"`;
	});

	// Sort participants by name length (longest first)
	const sortedMentionedList = [ ...(mentionedList || []) ].sort(
		(a, b) => (b?.name?.length || 0) - (a?.name?.length || 0)
	);

	// Replace mentions in the text with clickable elements
	return sortedMentionedList.reduce((acc, mention) =>
	{
		const mentionRegex = new RegExp(`@(${mention?.name})(?:\\b|\\s|$)`, 'gi');

		return acc.replace(mentionRegex, (match, name) =>
		{
			// Find the user ID from the mentioned list instead of current participant list
			const userId = mention?.id;

			return userId
				? `<span class="flexInline mention-wrapper" data-mention="${userId}">
				<span class='linkTxt pointer'>@${mention.name}</span>
				</span>`
				: `<span class="flexInline">@${name}</span>`;
		});
	}, linkifiedText);
};

export const getUserStatusList = (language) =>
{
	// return	[
	// 	{ available: language?.available, icon: '', color: '#00A800', key: 'available' },
	// 	{ busy: language?.busy, icon: '', color: 'red', key: 'busy' },
	// 	{ dnd: language?.doNotDisturb, icon: <RemoveIcon sx={{ fontSize: '12px', color: '#fff' }} />, color: 'red', key: 'dnd' },
	// 	{ beRightBack: language?.beRightBack, icon: <AccessTimeIcon sx={{ fontSize: '12px', color: '#fff' }} />, color: '#F9A928', key: 'beRightBack' },
	// 	{ away: language?.away, icon: <AccessTimeIcon sx={{ fontSize: '12px', color: '#fff' }} />, color: '#F9A928', key: 'away' },
	// 	{ offline: language?.offline, icon: <CloseIcon sx={{ fontSize: '12px', color: '#fff' }} />, color: 'gray', key: 'offline' }
	// ];

	return {
		available   : { available: language?.available, icon: '', color: '#00A800', key: 'available' },
		busy        : { busy: language?.busy, icon: '', color: 'red', key: 'busy' },
		dnd         : { dnd: language?.doNotDisturb, icon: <RemoveIcon sx={{ fontSize: '12px', color: '#fff' }} />, color: 'red', key: 'dnd' },
		beRightBack : { beRightBack: language?.beRightBack, icon: <AccessTimeIcon sx={{ fontSize: '12px', color: '#fff' }} />, color: '#F9A928', key: 'beRightBack' },
		away        : { away: language?.appearAway, icon: <AccessTimeIcon sx={{ fontSize: '12px', color: '#fff' }} />, color: '#F9A928', key: 'away' },
		offline     : { offline: language?.appearOffline, icon: <CloseIcon sx={{ fontSize: '12px', color: '#fff' }} />, color: 'gray', key: 'offline' }
	};
};

export async function uploadAttachment(fileList, folder, isGroupProfile = false)
{
	// this is for uploading files to inmeet s3 bucket
	// for collaboration module only
	try
	{
		const customPrefix = isGroupProfile ? folder : `public/${folder}/`;

		const uploadedFileList = fileList.map(async (file) =>
		{
			const fileName =
			`${file?.name?.replace(/ /g, '_').replace('+', '_')
				.split('.')[0]
			}${new Date().valueOf()}_${v4()?.split('-')[0]}` +
			`.${file?.name?.split('.')[file?.name?.split('.')?.length - 1]}`;

			const fullPath = `${customPrefix}${fileName}`;

			const urlBody = { key: fullPath, contentType: file.type };
			const presignedUrlResponse = await generatePresignedUrl(urlBody);

			if (!presignedUrlResponse?.status)
			{
				throw new Error('Failed to generate presigned URL');
			}
			const uploadResponse = await axios.put(presignedUrlResponse.data, file, {
				headers : {
					'Content-Type' : file.type
				}
			});

			if (uploadResponse.status !== 200)
			{
				throw new Error('Failed to upload file');
			}

			const cloudfrontUrl = process.env.REACT_APP_STAGE === 'development' || process.env.REACT_APP_STAGE === 'testing'
				? process.env.REACT_APP_INMEET_CLOUDFRONT_URL
				: process.env.REACT_APP_S3_CLOUDFRONT;

			// Construct the return body
			const body = {
				key   : fullPath,
				name  : fileName,
				title : fileName,
				type  : file.type,
				size  : file.size,
				url   : `${cloudfrontUrl}/${fullPath}`
			};

			return body;
		});

		return Promise.all(uploadedFileList)
			.then((res:object[]) =>
			{
				return res;
			})
			.catch((err) =>
			{
				catchErr(err);

				return [];
			});
	}
	catch (err:any)
	{
		// eslint-disable-next-line no-console
		console.error('Error during uploadAttachment:', err);
		throw err; // Re-throw the error for handling
	}
}